import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
	fetchInformationList,
	changeCurrentPath,
	resetMainListState,
	resetConsigneeListStateNew
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';

import DetailViewer from './components/detail-viewer';


const styles = theme => ({

});





class Information extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			detailData:{},
			detailIndex:null
		}
	}
	/** override methods **/

	UNSAFE_componentWillMount() {
		const {dispatch} = this.props;
		dispatch(fetchInformationList());
		dispatch(resetMainListState());
		dispatch(resetConsigneeListStateNew());
	}

	componentDidMount() {
		const { dispatch, history } = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}

	/** event handlers **/
	handleClickContents =(detailData, index)=>{
		this.setState({
			detailData,
			detailIndex:index
		})
	};

	handleClickCloseDetails = () =>{
		this.setState({
			detailData :{},
			detailIndex:null
		})
	};

	handleClickBeforeDetails = () =>{
		const detailData = this.props.settings.data[this.state.detailIndex - 1];
		this.setState({
			detailData,
			detailIndex:this.state.detailIndex - 1
		})

	};

	handleClickNextDetails = () =>{
		const detailData = this.props.settings.data[this.state.detailIndex + 1];
		this.setState({
			detailData,
			detailIndex:this.state.detailIndex + 1
		})

	};
	
	
	render() {
		const {settings,history} = this.props;
		const {isFetching, isProcessError, data} = settings;
		const {detailData, detailIndex} = this.state;
		const openDetail = !(Object.keys(detailData).length) ? false : true;

		const hasBefore = openDetail && detailIndex !== 0 && data.length > 1;
		const hasNext = openDetail && detailIndex !== data.length -1 && data.length > 1;


		const detailInner = data.map((dt,index)=> {
			return (
				<li key={index}>
					<dl>
						<dt>{dt.date}</dt>
						<dd className={"category_dt"}>{dt.cat}</dd>
						<dd className={"contents_dd"}><span
							onClick={this.handleClickContents.bind(this, dt, index)}>{dt.title}</span></dd>
					</dl>
				</li>

			);
		});

		return (
			<div id="main_container">
				{(isFetching) &&
				<Progress/>
				}
				<SpNav history={history}/>
				<Header history={history}/>
				<article>
					<section className="title_area">
						<h2>お知らせ</h2>
					</section>
					<section id="information_list">
						{data.length ?
							<ul>
								{detailInner}
							</ul>
							:
							<p>現在お知らせはありません</p>
						}
					</section>
				</article>
				<Footer/>
				<ErrorDialog
					open={isProcessError}
				/>
				<ReloadModal />
				<LogoutModal />
				{openDetail &&
				<DetailViewer
					title={detailData.title}
					date={detailData.date}
					cat={detailData.cat}
					contents={detailData.contents}
					afterCloseFunc={this.handleClickCloseDetails}
					clickBeforeFunc={this.handleClickBeforeDetails}
					clickNextFunc={this.handleClickNextDetails}
					hasBefore={hasBefore}
					hasNext={hasNext}
				/>
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.informationSettings
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(Information);




// WEBPACK FOOTER //
// ./src/routes/information/index.js